// extracted by mini-css-extract-plugin
export default {"nazwa_input":"Faktura_nazwa_input__FCNjW"};